import { useEffect, useState } from 'react';

/**
 * Global Ctrl/Cmd+K dinleyicisi — Command Palette aç/kapat state'i sağlar.
 * Esc kapatma palette içinde handle edilir.
 */
export function useCommandPalette() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    function onKeyDown(e: KeyboardEvent) {
      // Ctrl+K (Win/Linux) veya Cmd+K (Mac)
      if ((e.ctrlKey || e.metaKey) && (e.key === 'k' || e.key === 'K')) {
        e.preventDefault();
        setOpen((v) => !v);
      }
    }
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  return { open, setOpen };
}
